import React, {useEffect} from "react";
import "./App.css";
import {ThemeProvider} from "@vacasa/react-components-lib";
import _default from "@vacasa/react-components-lib/lib/themes/default";
import {Toaster} from "react-hot-toast";
import {Information} from "./components/information/information";

function App() {
    //resize iframe for each render
    useEffect(() => {
        const height = document.getElementById("root").clientHeight;
        window.parent.postMessage({action: `${height}px`, type: "resize"}, "*");
    });

    const renderMaintenanceMessage = () => {
        return (
            <div className="row">
                <div className="alert alert-warning">
                    <p>
                        <strong>The unit termination fields are in maintenance and will be enabled soon.</strong>
                    </p>
                    <p>
                        <strong>Saving the page won't update the unit termination fields.</strong>
                    </p>
                </div>
            </div>
        );
    };

    return (
        <div>
            <ThemeProvider theme={_default}>
                <Toaster position="top-right" reverseOrder={false} toastOptions={{duration: 8000}} />
                <div className="admin-app">
                    <div className="container-fluid no-padding-left">
                        <div className="container-custom">
                            <Information />
                        </div>
                    </div>
                </div>
            </ThemeProvider>
        </div>
    );
}

export default App;
